import { TEX } from '../config/constants';
import { ARCADE_HEX, ARCADE_TEXT } from '../config/theme';
import { INDICADORES, SEGMENTOS, segmentos, somar } from '../services/player1';
import { t } from '../services/textos';

export const ICONE_DO_INDICADOR = {
    fidelizacao: TEX.P1_ICON_FIDELIZACAO,
    confianca: TEX.P1_ICON_CONFIANCA,
    agilidade: TEX.P1_ICON_AGILIDADE,
    conexao: TEX.P1_ICON_CONEXAO
};

const MEDIDAS = {
    // Coluna do capítulo (Figma, quadro 4).
    compacto: { largura: 217, topo: 10, passo: 43.5, icone: 27, escala: 0.7, rotulo: 46, fonte: 16, barra: 28, seg: [3.94, 7.88, 7.88] },
    // Tela de perfil (quadro 15): com os valores e o total.
    amplo: { largura: 367, topo: 14, passo: 62, icone: 39, escala: 1, rotulo: 64, fonte: 26.6, barra: 40, seg: [5.3, 11, 10.6] }
};

/**
 * Os quatro indicadores do Player 1: ícone, nome e barra de 10 segmentos.
 * `valores: true` acrescenta o número de cada um e a linha TOTAL.
 */
export class PainelIndicadores {
    constructor (scene, x, y, { tamanho = 'compacto', valores = false } = {}) {
        this.scene = scene;
        this.m = MEDIDAS[tamanho];
        this.x = x;
        this.y = y;
        this.acesos = Object.fromEntries(INDICADORES.map(({ chave }) => [chave, 0]));
        this.objetos = [];

        const { m } = this;
        const altura = m.topo * 2 + INDICADORES.length * m.passo - (m.passo - m.barra - m.seg[1]) + (valores ? 56 : 0);
        const fundo = scene.add.graphics();
        fundo.fillStyle(ARCADE_HEX.BRANCO, 0.4).fillRoundedRect(x, y, m.largura, altura, 10);
        fundo.lineStyle(1, ARCADE_HEX.BRANCO, 1).strokeRoundedRect(x, y, m.largura, altura, 10);
        this.barras = scene.add.graphics();
        this.objetos.push(fundo, this.barras);

        const estilo = { ...ARCADE_TEXT.placar, fontSize: `${m.fonte}px` };
        this.numeros = {};
        INDICADORES.forEach(({ chave, rotulo }, i) => {
            const topo = this.topoDa(i);
            this.objetos.push(
                scene.add.image(x + m.icone, topo + m.barra / 2 + 4, ICONE_DO_INDICADOR[chave]).setScale(m.escala),
                scene.add.text(x + m.rotulo, topo - 2, rotulo, estilo)
            );
            if (valores) {
                this.numeros[chave] = scene.add.text(x + m.largura - 14, topo + 26, '', ARCADE_TEXT.placar).setOrigin(1, 0.5);
                this.objetos.push(this.numeros[chave]);
            }
        });

        if (valores) {
            const fio = this.topoDa(INDICADORES.length) - 1;
            fundo.lineStyle(1.4, ARCADE_HEX.TINTA, 1).lineBetween(x + 14, fio, x + m.largura - 14, fio);
            this.total = scene.add.text(x + m.largura - 14, fio + 29, '', ARCADE_TEXT.placar).setOrigin(1, 0.5);
            this.objetos.push(
                scene.add.text(x + 14, fio + 29, t('geral.total'), { ...ARCADE_TEXT.placar, fontStyle: '700' }).setOrigin(0, 0.5),
                this.total
            );
        }
        this.desenharBarras();
    }

    topoDa (indice) {
        return this.y + this.m.topo + indice * this.m.passo;
    }

    desenharBarras () {
        const { m } = this;
        this.barras.clear();
        INDICADORES.forEach(({ chave }, i) => {
            for (let s = 0; s < SEGMENTOS; s++) {
                this.barras.fillStyle(s < this.acesos[chave] ? ARCADE_HEX.TINTA : 0x9b9b8f, 1)
                    .fillRect(this.x + m.rotulo + s * m.seg[2], this.topoDa(i) + m.barra, m.seg[0], m.seg[1]);
            }
        });
    }

    /** Atualiza barras (e números). Com `animar`, os segmentos sobem ou descem um a um. */
    definir (indicadores, { animar = false } = {}) {
        const alvo = Object.fromEntries(INDICADORES.map(({ chave }) => [chave, segmentos(indicadores[chave])]));
        INDICADORES.forEach(({ chave }) => this.numeros[chave]?.setText(String(indicadores[chave])));
        this.total?.setText(String(somar(indicadores)));

        this.passos?.remove();
        if (!animar) {
            this.acesos = alvo;
            this.desenharBarras();
            return;
        }
        this.passos = this.scene.time.addEvent({
            delay: 110, repeat: SEGMENTOS, callback: () => {
                INDICADORES.forEach(({ chave }) => {
                    this.acesos[chave] += Math.sign(alvo[chave] - this.acesos[chave]);
                });
                this.desenharBarras();
            }
        });
    }

    destroy () {
        this.passos?.remove();
        this.objetos.forEach((objeto) => objeto.destroy());
    }
}
